// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__35m_y","range":"MonthRangeSwitch_range__-bKC2","disabled":"MonthRangeSwitch_disabled__3sXg6"};